import React from "react";
import { useNavigate } from "react-router-dom";
import RatingIndicator from "../RatingIndicator";
import styles from "../../../assets/styles/cardNews/CardHorizontalWithThumbnail.module.css";
import img from "../../../assets/images/thumbnail_default.jpg";
import PressNDate from "./PressNDate";
import { Obscure } from "../\bobscuredImage";

const CardHorizontalWithThumbnail = ({ news, main }) => {
  const navigate = useNavigate();
  const pathname = window.location.pathname;
  // const isDetail = pathname.includes('industry')
  // console.log(pathname, isDetail,  '--')
  const moveToSingleNews = () => {
    navigate(`/single-news/${news.newsid}`);
  };
  const moveToTimeline = () => {
    navigate(`/${news.newsid}/timeline`);
  };

  return (
    <div className={`${styles.card_container} ${main}`}>
      <div className={styles.card_top}>
        <RatingIndicator
          signal={news.signal}
          percent={news.staticsentimental.percent}
        />
        <span className={styles.stockname}>{news.stockname}</span>
      </div>
      <div className={styles.card_contents} onClick={moveToSingleNews}>
        <div>
          <div className={styles.card_news}>
            <p className={`${styles.title} ${main}`}>{news.subject}</p>
            <p className={styles.summary}>{news.summary}</p>
          </div>
          <div className={styles.card_footer}>
            {/*<span>{news.press}·{news.registdate.slice(-5)}</span>*/}
            <PressNDate press={news.press} date={news.registdate} />
            {news.samenewscounts > 0 && (
              <span className={styles.newscnt} onClick={moveToTimeline}>
                연관뉴스 {news.samenewscounts}건 보기 >{" "}
              </span>
            )}
          </div>
        </div>

        <div className={styles.card_thumbnail_container}>
          <Obscure text={news?.press}>
            <img
              className={styles.thumbnail}
              src={news.imgsrc || img}
              alt={news.subject}
            />
          </Obscure>
        </div>
      </div>
    </div>
  );
};

export default CardHorizontalWithThumbnail;
